module.exports = __webpack_public_path__ + "media/images/auto-grow-card-199-a45a4eb1.png";